var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_740)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9064 22.8125H14.581C14.2767 22.8125 13.9976 22.622 13.9069 22.3316C13.7971 21.9798 13.9809 21.6119 14.316 21.4835L19.4729 19.5001C19.8351 19.3607 20.0091 18.9501 19.8596 18.5919C17.8253 13.7165 17.3163 7.70272 17.3105 7.63199C17.2581 6.98514 16.4152 6.76394 16.0532 7.30586L15.0594 8.79645L13.5692 7.80301C13.1748 7.53974 12.6359 7.74659 12.5207 8.20821L12.0696 10.0116L10.8192 9.17802C10.4248 8.91474 9.88594 9.1216 9.77074 9.58321L9.31956 11.3866L8.06917 10.553C7.59281 10.2354 6.95739 10.6073 7.00225 11.1782C7.016 11.3565 7.35588 15.598 8.64538 19.9155C9.41367 22.4872 10.3633 24.5463 11.4676 26.0364C12.2425 27.0811 13.4302 27.625 14.6302 27.625H14.8699C16.1904 27.625 17.2923 26.5764 17.3124 25.256C17.3328 23.9121 16.2456 22.8125 14.9064 22.8125ZM10.4866 15.5052C10.3457 15.1528 10.5171 14.7528 10.8699 14.6114L14.3074 13.2364C14.6597 13.0955 15.0598 13.2669 15.2011 13.6197C15.3421 13.9721 15.1706 14.3721 14.8179 14.5135C11.0952 16.0025 11.3149 15.9375 11.1251 15.9375C10.8527 15.9375 10.5945 15.7742 10.4866 15.5052ZM12.0679 18.6385C11.7205 18.7774 11.3171 18.6119 11.1741 18.2552C11.0332 17.9029 11.2046 17.5028 11.5574 17.3614L14.9949 15.9864C15.3472 15.8455 15.7473 16.017 15.8887 16.3697C16.0296 16.7221 15.8581 17.1221 15.5054 17.2635L12.0679 18.6385ZM25.5627 18.6875C25.3831 18.6875 25.7382 18.5711 20.7678 20.4827C20.7617 20.4727 17.4425 21.7541 17.4481 21.7519C17.2036 21.846 17.1513 22.1664 17.3509 22.336C19.4429 24.1125 19.0084 27.4467 16.5335 28.6316C16.3488 28.72 16.4107 28.9997 16.6155 29C17.1864 29.001 17.7343 28.8616 18.2133 28.6116L25.6267 25.5591C25.7676 25.5462 25.8965 25.4907 25.9997 25.4057C28.0088 24.5787 27.9144 24.6396 28.051 24.4969C30.1279 22.3194 28.572 18.6875 25.5627 18.6875Z",
    fill: "url(#paint1_linear_224_740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_740",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_740",
    x1: 27.4406,
    y1: 10.9728,
    x2: 2.93423,
    y2: 11.7718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingDashboard);
export default __webpack_public_path__ + "static/media/billing-dashboard.9b036c61069a46a762acbf4caecfa85b.svg";
export { ForwardRef as ReactComponent };